// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
      .dialog-container {
        padding: 20px;
        min-width: 350px;
      }
      .dialog-title {
        margin: 0 0 20px 0;
        color: #333;
      }
      input {
        width: 100%;
        padding: 10px;
        border: 1px solid #ddd;
        border-radius: 4px;
        font-size: 14px;
      }
      .dialog-actions {
        display: flex;
        justify-content: flex-end;
        gap: 10px;
      }
    `, "",{"version":3,"sources":["webpack://./projects/tilmanagement/src/app/technical-letters/input-dialog/input-dialog.component.ts"],"names":[],"mappings":";MACM;QACE,aAAa;QACb,gBAAgB;MAClB;MACA;QACE,kBAAkB;QAClB,WAAW;MACb;MACA;QACE,WAAW;QACX,aAAa;QACb,sBAAsB;QACtB,kBAAkB;QAClB,eAAe;MACjB;MACA;QACE,aAAa;QACb,yBAAyB;QACzB,SAAS;MACX","sourcesContent":["\n      .dialog-container {\n        padding: 20px;\n        min-width: 350px;\n      }\n      .dialog-title {\n        margin: 0 0 20px 0;\n        color: #333;\n      }\n      input {\n        width: 100%;\n        padding: 10px;\n        border: 1px solid #ddd;\n        border-radius: 4px;\n        font-size: 14px;\n      }\n      .dialog-actions {\n        display: flex;\n        justify-content: flex-end;\n        gap: 10px;\n      }\n    "],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
